import type { ApiItem } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';

export type CultureMapItem = ApiItem & {
    uniqueId: string;
    linkedItems?: Array<CultureMapItemModel>;

    iconPath: string;
    imagePath?: string;
    thumbnailPath?: string;
};

export class CultureMapItemModel extends MapItem implements CultureMapItem {
    public linkedItems?: Array<CultureMapItemModel>;

    public imagePath?: string;
    public thumbnailPath?: string;

    constructor(mapItem: CultureMapItem) {
        super(
            mapItem,
            mapItem.uniqueId,
        );

        this.iconPath = mapItem.iconPath;
        this.imagePath = mapItem.imagePath;
        this.thumbnailPath = mapItem.thumbnailPath;

        this.linkedItems = mapItem.linkedItems;
    }
}
